export default function Machines_A_1 (number = 1) {
  return {
    name: '无线输电塔',
    icon: '/static/img/machines/a1.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_1.js